module.exports = __webpack_public_path__ + "static/media/tarifs.d01bb107.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/aa/form/tarifs.xlsx
// module id = 822
// module chunks = 40